import $ from 'jquery'
import Base from 'luminate/src/modules/base'

export default Base.extend({
	directive: 'submit-on-change',

	events: {
		init: function() {
			const $element = $(this.$element)

			$element.find('select[name]').change(function() {
				if ($(this).val() != '') {
					$element.submit()
				}
			})
		}
	}
})



// WEBPACK FOOTER //
// ./source/scripts/legacy/modules/submit-on-change.js